define.alias("shared/components/shared/wizard/cancel-button", "settings/components/shared/wizard/cancel-button");